export default __webpack_public_path__ + "static/media/2012.41aaae77.png";